/**
 * SocialMediaStrip Functional Component
 * @Package - seo
 * @Author - Manila@UPWA-Team
 * @description: SocialMediaStrip for SEO pages
 */

import React from "react";
import { Box } from "@usap/uicomponents";

export default function SocialMediaStrip({ id, data }) {
  return (
    <Box
      id={id}
      margin={{ horizontal: "auto", vertical: "0px" }}
      pad={{ horizontal: "0px", vertical: "0px" }}
    >
      <div
        dangerouslySetInnerHTML={{ __html: data || "" }}
        style={{
          width: "100%"
        }}
      />
    </Box>
  );
}
